import { Component, input } from '@angular/core';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

import { UiPalette } from '../../../types/UiPalette.type';

@Component({
  selector: 'eiq-badge',
  templateUrl: 'badge.component.html',
  styleUrls: ['./badge.component.scss', './_badge-theme.component.scss']
})
export class BadgeComponent {
  background = input<'initial' | 'transparent'>('initial');
  color = input<UiPalette>();
  icon = input<IconDefinition>();
  indicator = input<boolean>(false);
  text = input<string>();
  shape = input<'rounded' | 'square'>('rounded');
  height = input<'medium' | 'small' | 'tiny'>('small');
  useDark = input<boolean>(false);
}
